/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { urlsAndEmail } from 'const';

import Styles from './styles';

const useStyles = makeStyles(Styles);

export default function StripeInfoContainer() {
  const styles = useStyles();
  const { t } = useTranslation('labels');

  return (
    <Box sx={{ width: '100%' }} className={styles.stripeInfoContainer}>
      <a href="https://stripe.com" rel="noreferrer" target="_blank">
        <img src={urlsAndEmail.poweredByStripe} alt={t('powered_by_stripe')} className={styles.poweredByImg} />
      </a>
      <Box sx={{ width: '100%' }} className={styles.stripeBox}>
        <Typography variant="h5" component="h5" className={styles.stripeTitle} color="primary">
          {t('why_stripe')}
        </Typography>
        <Typography variant="p" component="p">
          {t('secure_and_convenient_patient_payments')}
        </Typography>
        <Typography variant="p" component="p">
          {t('privacy_assurance')}
        </Typography>
      </Box>

      <Box sx={{ width: '100%' }} className={styles.stripeSecondaryBox}>
        <Typography variant="h5" component="h5" className={styles.stripeTitle} color="primary">
          {t('want_to_know_more_about_stripe')}
        </Typography>
        <a href="https://stripe.com/en-ca/newsroom/information" rel="noreferrer" target="_blank">
          <img src={urlsAndEmail.stripe} alt={t('stripe')} className={styles.stripeLogo} />
        </a>
        <a href="https://stripe.com/docs" rel="noreferrer" target="_blank" className={styles.stripeDocumentation}>
          <Typography variant="p" component="p">
            {t('stripe_documentation')}
          </Typography>
        </a>
      </Box>

      <Box sx={{ width: '100%' }} className={styles.stripeSecondaryBox}>
        <a href={urlsAndEmail.supportPaymentUrl} rel="noreferrer" target="_blank" className={styles.supportDocumentationLink}>
          <Typography variant="p" component="p" className={styles.stripeTitle} color="primary">
            {t('adracare_support_documentation')}
          </Typography>
        </a>
      </Box>
    </Box>
  );
}
